import bgImg2 from '../images/background/4.png';


const dataSlider = [
    {
        id: 2,
        title: 'Animus Labs',
        desc : 'Elevating Dreams, Crafting Realities: Where Your Web3 Games Come to Life.',
        bgImg: bgImg2,
        classAction: 'two',
    },
]

export default dataSlider;